import { render, staticRenderFns } from "./matching-card-wrapper.vue?vue&type=template&id=49b0572e&scoped=true&"
import script from "./matching-card-wrapper.vue?vue&type=script&lang=ts&"
export * from "./matching-card-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-wrapper.vue?vue&type=style&index=0&id=49b0572e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b0572e",
  null
  
)

export default component.exports